<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-2">
        <b-field>
          <form-input label="№" type="number" v-model="form.order_num"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input label="Наименование *" v-model="form.name"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-datepicker label="Дата начала *" v-model="form.start_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <form-textarea label="Описание" v-model="form.description"></form-textarea>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker label="Плановая дата завершения" v-model="form.end_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker label="Фактическая дата завершения" v-model="form.completed_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <b-checkbox v-model="form.is_completed">Завершено?</b-checkbox>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">Сохранить</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">Отменить</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDate} from '@/utils'

  const defaultPhaseData = {
    order_num: null,
    name: '',
    description: '',
    start_date: new Date(),
    end_date: null,
    completed_date: null,
    is_completed: false
  }

  export default {
    props: ['phaseData', 'editMode'],
    data() {
      return {
        form: this.phaseData || {...defaultPhaseData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        let isValid = true
        this.errors = []
        if (this.form.name === '') {
          this.errors.push(this.$t('interface.requiredFields'))
          isValid = false
        }
        return isValid
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            start_date: prepareDate(this.form.start_date),
            end_date: this.form.end_date ? prepareDate(this.form.end_date) : null,
            completed_date: this.form.completed_date ? prepareDate(this.form.completed_date) : null,
            order_num: this.form.order_num === '' ? null : this.form.order_num
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    watch: {
      phaseData(data) {
        this.form = data
      }
    }
  }
</script>